import React from "react";
import { PostModel } from "../../features/post/postTypes";
import "./Posts.css";
import { Link } from "react-router-dom";
import { Card, Row, Col, Image } from "react-bootstrap";

type Props = {
  posts: PostModel;
};

const PostsListItem = ({ posts }: Props) => {
  const dateStr = posts.posted_at;
  const date: Date = new Date(dateStr);
  const formattedDate: string = date.toLocaleDateString("en-US", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
  const result = `${formattedDate.slice(0, 2)}.${formattedDate.slice(
    3,
    5
  )}.${formattedDate.slice(6)}`;

  return (


          <Card bg="secondary" className="mb-2 card mt-2 col-md-4 flex-nowrap">
            <Card.Body className="p-0 ">
              <Row>
                <Col lg={true}>
                  <Image
                      src={posts.thumbnail}
                      alt="Thumbnail"
                      className="post-thumb"
                  />
                </Col>
                <Col className="p-2 main-col align-items-center">
                  <Row>
                    <Col className="">
                      <div className="d-flex align-items-top upper-content">
                        <h4 className="d-inline-block m-0 font-style-bold main-text">
                          {posts.title}
                        </h4>
                        <h5 className="ml-auto">{result}</h5>
                      </div>
                    </Col>
                  </Row>
                  <Card.Text
                      dangerouslySetInnerHTML={{ __html: posts.lead }}
                      className="description-text"
                  ></Card.Text>
                  <Link
                      to={`/post/${posts.slug}`}
                      className="nav-link text-decoration-none link-white"
                  >
                    READ MORE
                  </Link>
                </Col>
              </Row>
            </Card.Body>
          </Card>

  );
};

export default PostsListItem;
